/**
 * @generated SignedSource<<909fadf6aed9068d9c4fa38817c38cbb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sectionSearchResultListItemSection$data = {
  readonly entityId: string;
  readonly fullSectionPath: ReadonlyArray<{
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIfNewsSectionInFirstIndexSection">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "sectionSearchResultListItemSection";
};
export type sectionSearchResultListItemSection$key = {
  readonly " $data"?: sectionSearchResultListItemSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"sectionSearchResultListItemSection">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "sectionSearchResultListItemSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "helpersCheckIfNewsSectionInFirstIndexSection",
          "selections": [
            (v0/*: any*/)
          ],
          "args": null,
          "argumentDefinitions": []
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Section",
  "abstractKey": null
};
})();

(node as any).hash = "5766bf61a1c3da43cfeb718602ba12e6";

export default node;
